export default __webpack_public_path__ + "static/img-art-pandas-profiling-7-96858f693e0e0b6d28d23c233b89965f.png";